import { useEffect } from 'react'
import { subscribeVisibleSlice, trackVisibleSlice } from '../utils/visible_slice'

// Runs onChange whenever the frame's visible slice moves while active
// (utils/visible_slice). Tracking starts at mount, not at activation, so the
// slice is already known when an overlay first opens. Inert on our own
// portal, where nothing is ever observed.
const useVisibleSlice = (active, onChange) => {
  useEffect(() => { trackVisibleSlice() }, [])

  useEffect(() => {
    if (!active) {
      return undefined
    }

    return subscribeVisibleSlice(onChange)
  }, [ active, onChange ])
}

export default useVisibleSlice
